import _ from "lodash";
import * as React from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaEmptyState from "../../../../ui-kit/kuika-empty-state/kuika-empty-state";
import KuikaTable, { KuikaTableColumn } from "../../../../ui-kit/kuika-table/kuika-table";
import KuikaH5 from "../../../../ui-kit/typography/H5/H5";
import KuikaText from "../../../../ui-kit/typography/Text/Text";
import "./table-preview.scss";

export interface ITablePreviewProps {
  testDataSource: any[];
  testColumns: any[];
  onTestClick: () => void;
  hasTested: boolean;
  isLoading: boolean;
}

export const TablePreviewComponent: React.FC<ITablePreviewProps> = ({
  testDataSource,
  testColumns,
  onTestClick,
  hasTested,
  isLoading
}) => {
  const columns: KuikaTableColumn<any>[] = React.useMemo(() => {
    return testColumns.map((col) => {
      const isBooleanColumn = typeof col.value === "boolean";

      return {
        id: col.key,
        header: () => col.title,
        cell: (row: any) => {
          const value = row[col.dataIndex];
          let displayValue: string;
          if (isBooleanColumn && typeof value === "boolean") {
            displayValue = value ? "True" : "False";
          } else {
            displayValue = value?.toString() ?? "";
          }
          return (
            <div
              style={{
                whiteSpace: "nowrap"
              }}
              title={displayValue}
            >
              {displayValue}
            </div>
          );
        },
        accessorKey: col.dataIndex,
        enableSorting: true,
        enableColumnFilter: false,
        align: "left"
      };
    });
  }, [testColumns]);

  if (!hasTested) {
    return (
      <div className="generic-sql__preview-empty-state">
        <KuikaEmptyState
          svgName="table"
          customName=""
          description=""
          hideDescription={true}
          svgWidth={64}
          svgHeight={64}
        />
        <div className="generic-sql__preview-empty-state__content">
          <KuikaH5>Preview Now</KuikaH5>
          <KuikaText>Run a test to preview the query results and check if everything looks right.</KuikaText>
          <KuikaButton type="secondary" size="sm" onClick={onTestClick} loading={isLoading}>
            TEST
          </KuikaButton>
        </div>
      </div>
    );
  }

  if (hasTested && (testDataSource.length === 0 || (testDataSource.length === 1 && _.isEmpty(testDataSource[0])))) {
    return (
      <div className="generic-sql__preview-empty-state">
        <KuikaEmptyState svgName="search" customName="" hideDescription={true} svgWidth={64} svgHeight={64} />
        <div className="generic-sql__preview-empty-state__content">
          <KuikaH5>No Results Found</KuikaH5>
          <KuikaText>
            This query ran successfully but didn't return any results. Try adjusting filters, conditions, or selected
            fields.
          </KuikaText>
          <KuikaButton type="secondary" size="sm" onClick={onTestClick} loading={isLoading}>
            TEST AGAIN
          </KuikaButton>
        </div>
      </div>
    );
  }

  // Data state - show table with results
  return (
    <div className="generic-sql__preview">
      <div className="generic-sql__preview-table">
        <KuikaTable
          data={testDataSource}
          columns={columns}
          rowKey={(row) => row.id ?? Math.random().toString()}
          enablePagination={false}
          enableSorting={true}
          pageSize={testDataSource.length}
          layoutMode="auto"
        />
      </div>
    </div>
  );
};
